module.exports = __webpack_public_path__ + "./images/monitored-objects.svg";